import React, { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { PageTitle, Fab, RowActions, EmptyState } from "@/components/shared";
import DataDialog from "@/components/DataDialog";
import { formatDate } from "@/lib/format";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export default function PasanganPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = async () => { const { data } = await api.get("/pasangan"); setItems(data); };
  useEffect(() => { load(); }, []);

  const fields = [{ name: "nama", label: "Nama Pasangan (nama kelompok)", type: "text", required: true }];

  const onSave = async (payload) => {
    if (editing) { await api.put(`/pasangan/${editing.id}`, payload); toast.success("Pasangan diperbarui"); }
    else { await api.post("/pasangan", payload); toast.success("Pasangan ditambahkan"); }
    await load();
  };
  const del = async (id) => { await api.delete(`/pasangan/${id}`); toast.success("Dihapus"); load(); };
  const toggle = async (p) => { await api.put(`/pasangan/${p.id}`, { active: !p.active }); load(); };

  const sorted = [...items].sort((a, b) => (a.created_at || "").localeCompare(b.created_at || ""));

  return (
    <div>
      <PageTitle title="Pasangan" subtitle="Kelola kelompok pasangan (sysadmin)" />
      <div className="rounded-xl border border-border">
        <Table>
          <TableHeader><TableRow>
            <TableHead>ID Pasangan</TableHead><TableHead>Nama</TableHead><TableHead>Aktif</TableHead>
            <TableHead>Dibuat</TableHead><TableHead className="text-right">Aksi</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {sorted.map((p) => (
              <TableRow key={p.id} data-testid={`row-${p.id}`}>
                <TableCell className="font-mono text-xs">{p.id}</TableCell>
                <TableCell className="font-medium">{p.nama}</TableCell>
                <TableCell><Switch data-testid={`toggle-${p.id}`} checked={!!p.active} onCheckedChange={() => toggle(p)} /></TableCell>
                <TableCell className="text-xs text-muted-foreground">{formatDate(p.created_at)}</TableCell>
                <TableCell><RowActions id={p.id} onEdit={() => { setEditing(p); setOpen(true); }} onDelete={() => del(p.id)} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {sorted.length === 0 && <EmptyState text="Belum ada pasangan." />}
      </div>
      <Fab testId="fab-pasangan" onClick={() => { setEditing(null); setOpen(true); }} />
      <DataDialog open={open} onOpenChange={setOpen} title={editing ? "Edit Pasangan" : "Tambah Pasangan"} fields={fields} initial={editing} onSave={onSave} />
    </div>
  );
}
